export default function (role, strict = false) {
  if (!role) {
    return false;
  }

  const roles = Array.isArray(role) ? role : [role]; 

  const storedRoleAccess = localStorage.getItem("roleAccess") || ""; 
  const roleAccess = storedRoleAccess.split(",").map((r) => parseInt(r));
  const roleId = parseInt(localStorage.getItem("roleId"));

  if (strict) {
    return roles.some((r) => roleId === r.roleId);
  }

  return roles.some((r) => roleAccess.includes(r.roleId));
}



// WEBPACK FOOTER //
// ./src/utils/userHasAccess.js